import React from "react";

const Head = () => {
  return (
    <>
      <section className="head bg-blue-950 text-white py-[1px] md:py-[1px]">
        <div className="container flex flex-col md:flex-row justify-between">
          <div className="left flex items-center mb-2 md:mb-0">
            <i className="fa fa-phone mr-2"></i>
            <label className="mr-4"> +88012 3456 7894</label>
            <i className="fa fa-envelope mr-2"></i>
            <label> support@snkmusicstore.com</label>
          </div>
          <div className="right flex items-center">
            <label className="mr-4">Theme FAQ's</label>
            <label className="mr-4">Need Help?</label>
            <span className="mr-2">🏳️‍⚧️</span>
            <label className="mr-2">IN</label>
            <span className="mr-2">🏳️‍⚧️ </span>
            <label className="mr-2">Rs. 🇮🇳</label>
          </div>
        </div>
      </section>
    </>
  );
};

export default Head;
